import { render, staticRenderFns } from "./ProfileReports.vue?vue&type=template&id=b8923fb4&scoped=true&"
import script from "./ProfileReports.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ProfileReports.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8923fb4",
  null
  
)

export default component.exports